import template from './sw-cms-block-preview-category-navigation.html.twig';
import './sw-cms-block-preview-category-navigation.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
